module.exports = __webpack_public_path__ + "static/img/product-img3.0697b57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/product-img3.jpg
// module id = cDuh
// module chunks = 0